import api from '@/api/axios';
import { Checkout, Portal, Response } from './types';

let chargebeeInstance: any = null;

export const loadChargebeeScript = () => {
  return new Promise((resolve, reject) => {
    if (document.getElementById('chargebee-js')) {
      resolve(true);
      return;
    }

    const script = document.createElement('script');
    script.id = 'chargebee-js';
    script.src = 'https://js.chargebee.com/v2/chargebee.js';
    script.async = true;
    script.onload = () => resolve(true);
    script.onerror = () => reject(new Error('Failed to load Chargebee script'));
    document.body.appendChild(script);
  });
};

export const unloadChargebeeScript = () => {
  const script = document.getElementById('chargebee-js');

  if (script) {
    script.remove();
    chargebeeInstance = null;
  }

  const additionalScripts = document.querySelectorAll(
    'script[src^="https://js.chargebee.com/assets"]',
  );
  additionalScripts.forEach((script) => {
    script.remove();
  });

  window.Chargebee = undefined;
};

export const initializeChargebee = (site: string) => {
  if (!window.Chargebee) {
    throw new Error('Chargebee script not loaded');
  }

  chargebeeInstance = window.Chargebee.init({
    site: site,
  });

  return chargebeeInstance;
};

export const openPortal = (portaldata: Portal) => {
  chargebeeInstance.setPortalSession(() => {
    return Promise.resolve(portaldata);
  });

  const portalInstance = chargebeeInstance.createChargebeePortal();
  portalInstance.open();
};

export const openCheckout = (
  checkoutData: Checkout,
  onBookingSuccessful: () => void,
) => {
  chargebeeInstance.openCheckout({
    hostedPage: () => Promise.resolve(checkoutData),
    close: () => {
      onBookingSuccessful();
    },
  });
};

export const openCheckoutOrPortal = (): Promise<Response> => {
  return api.get(`/api/payments/chargebee/checkoutorportal?product=neolexon`);
};
